import React from 'react';
import { StorageKeys } from 'constants/constants';
import { storageAvailable } from 'utils/utils';

class Page extends React.Component {
  
  state = {
    error: null,
  }

  componentDidMount() {
    if(storageAvailable()) {
      console.log("LOCAL STORAGE USED");
      window.localStorage.setItem(StorageKeys.AUTH_CODE, location.toString());
      window.localStorage.removeItem(StorageKeys.AUTH_CODE);
    } else {
      this.setState({ error: "Local storage is blocked. We cannot log you in with Twitch." })
      console.error("LOCAL STORAGE NOT AVAILABLE");
    }
  }

  render() {
    let { error } = this.state;
    return (<div>
      { error && 
      <div>{ error }</div>}
    </div>);
  }
}
export default Page;